export default "__VITE_ASSET__19863cb4__"